import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

const QUERY = gql`
  query getKnowledgebaseCategories($accountId: String!) {
    knowledgebaseCategories(accountId: $accountId) {
      id
      accountId
      text
    }
  }
`;

const useKnowledgebaseCategories = (accountId: string) => {
  return useQuery(QUERY, {
    variables: { accountId },
  });
};

export default useKnowledgebaseCategories;
